module.exports = __webpack_public_path__ + "static/media/leaf.630971fb.svg";